import {
  setActiveAssistant,
  setDataAssistants,
  setNewAssistant,
  setRebuildInstructionDialogId,
} from "../../../store/slices/assistantSlice";
import { setDataInstructions } from "../../../store/slices/instructionsSlice";
import { removeUser } from "../../../store/slices/userSlice";
import { errorToast, infoToast } from "../../methods/toast";
import { $authHost, $hostTest } from "../http";
import { getDialog } from "./dialogs";

let userId = localStorage.getItem("@storage_User_Id");

export const getAssistantList = (id) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.get(`/assistant/list?userId=${id}`);

      if (data.code === 200) {
        dispatch(setDataAssistants(data.assistants));
        localStorage.setItem("dataAssistants", JSON.stringify(data.assistants));
      } else {
        errorToast(
          "Ошибка получения списка ассистентов: " +
            (data.message || "Неизвестная ошибка")
        );
      }
    } catch (error) {
      if (error.response) {
        switch (error.response.status) {
          case 401:
            dispatch(removeUser());
            break;
          case 500:
            errorToast("Ошибка на сервере. Пожалуйста, попробуйте позже.");
            break;
          default:
            break;
        }
      } else if (error.request) {
        errorToast(
          "Ошибка связи с сервером. Пожалуйста, проверьте ваше интернет-соединение."
        );
      } else {
        errorToast("Произошла ошибка: " + error.message);
      }

      console.error("getAssistantList error", error);
    }
  };
};

export const getAssistantById = (id) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.get(`/assistant/get?id=${id}`);

      if (data.code === 200) {
        dispatch(setActiveAssistant(data.assistant));
        localStorage.setItem("activeAssistant", JSON.stringify(data.assistant));
        // console.log(data);
      } else {
        errorToast(
          "Ошибка получения списка ассистентов: " +
            (data.message || "Неизвестная ошибка")
        );
      }
    } catch (error) {
      if (error.response) {
        switch (error.response.status) {
          case 401:
            dispatch(removeUser());
            break;
          case 500:
            errorToast("Ошибка на сервере. Пожалуйста, попробуйте позже.");
            break;
          default:
            break;
        }
      } else if (error.request) {
        errorToast(
          "Ошибка связи с сервером. Пожалуйста, проверьте ваше интернет-соединение."
        );
      } else {
        errorToast("Произошла ошибка: " + error.message);
      }

      console.error("getAssistantList error", error);
    }
  };
};

export const postNewAssistant = (dataAssistant, navigate) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.post("/assistant/new", dataAssistant);

      if (data.code === 200) {
        // dispatch(getAssistantList(userId));
        dispatch(getAssistantById(data.assistant.id));
        dispatch(setNewAssistant(null));
        navigate("/assistants");
        // console.log("postNewAssistant", data);
      } else {
        errorToast(
          "Ошибка при добавлении нового ассистента: " +
            (data.message || "Неизвестная ошибка")
        );
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере. Пожалуйста, попробуйте позже.");
        }
      } else if (error.request) {
        errorToast(
          "Ошибка связи с сервером. Пожалуйста, проверьте подключение."
        );
      } else {
        errorToast("Произошла ошибка: " + error.message);
      }

      dispatch(getAssistantList(userId));
      console.error("postNewAssistant error", error);
    }
  };
  // console.log('dataAssistant', dataAssistant);
};

export const postAddAssistantFiles = (formData, setLoadingFiles) => {
  return async (dispatch) => {
    try {
      setLoadingFiles(true);
      const { data } = await $authHost.post("/assistant/add-files", formData);

      if (data.code === 200) {
        infoToast("Файлы добавлены");
        dispatch(setActiveAssistant(data.assistant));
        // console.log("postAddAssistantFiles", data);
        setLoadingFiles(false);
      } else {
        setLoadingFiles(false);
        errorToast(
          "Ошибка при добавлении файлов: " +
            (data.message || "Неизвестная ошибка")
        );
      }
    } catch (error) {
      setLoadingFiles(false);
      if (error.response) {
        // Обработка ошибок на уровне ответа
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере. Пожалуйста, попробуйте позже.");
        }
      } else if (error.request) {
        // Ошибка связи с сервером
        errorToast(
          "Ошибка связи с сервером. Пожалуйста, проверьте подключение."
        );
      } else {
        // Ошибка на уровне запроса или внутренней логики
        errorToast("Произошла ошибка: " + error.message);
      }

      dispatch(getAssistantList(userId));
      console.error("postAddAssistantFiles error", error);
    }
  };
};

export const teachAssistant = (dataTeach) => {
  return async (dispatch) => {
    try {
      const { data } = await $hostTest.post("/assistant/teach", dataTeach);
      if (data.code === 200) {
        console.log("teachAssistant", data);
      }
    } catch (error) {
      console.log("teachAssistant error: ", error);
    }
  };
};

export const deleteAssistantFile = (id) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.delete(
        `/assistant/file/delete?id=${id}`
      );

      if (data.code === 200) {
        infoToast("Файл был успешно удален");
        dispatch(getAssistantList(userId));
        console.log("deleteAssistantFile", data);
        return { success: true, data }; // Возвращаем результат
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере. Пожалуйста, попробуйте позже.");
        }
      } else if (error.request) {
        errorToast(
          "Ошибка связи с сервером. Пожалуйста, проверьте подключение."
        );
      } else {
        errorToast("Произошла ошибка: " + error.message);
      }

      dispatch(getAssistantList(userId));
      console.error("deleteAssistantFile error", error);
      return { success: false, message: error.message }; // Возвращаем ошибку
    }
  };
};

// export const putAssistant = (dataAssistant) => {
//   return async (dispatch) => {
//     try {
//       const { data } = await $authHost.put("/assistant/update", dataAssistant);

//       if (data.code === 200) {
//         // dispatch(getAssistantList(userId));
//         // dispatch(setActiveAssistant(data.assistant));
//         dispatch(getAssistantById(data.assistant.id));
//         return data.assistant;
//       } else {
//         errorToast(
//           "Ошибка обновления ассистента: " +
//             (data.message || "Неизвестная ошибка")
//         );
//         return null;
//       }
//     } catch (error) {
//       if (error.response) {
//         // Обработка ошибок на уровне ответа
//         if (error.response.status === 401) {
//           dispatch(removeUser());
//         } else if (error.response.status === 500) {
//           errorToast("Ошибка на сервере. Пожалуйста, попробуйте позже.");
//         }
//       } else if (error.request) {
//         // Ошибка связи с сервером
//         errorToast(
//           "Ошибка связи с сервером. Пожалуйста, проверьте подключение."
//         );
//       } else {
//         // Ошибка на уровне запроса или внутренней логики
//         errorToast("Произошла ошибка: " + error.message);
//       }

//       dispatch(getAssistantList(userId));
//       console.error("putAssistant error", error);
//       return null;
//     }
//   };
// };

const formatTime = (dateTime) => {
  // Если формат в целом "DD-MM-YYYY HH:mm:ss", можно просто взять часть времени:
  const timePart = dateTime.split(" ")[1];
  return timePart || dateTime;
};

export const putAssistant = (dataAssistant) => {
  return async (dispatch) => {
    try {
      const payload = {
        ...dataAssistant,
        assistantId: dataAssistant.id,
      };
      delete payload.id;

      if (payload.settings) {
        payload.settings = {
          ...payload.settings,
          startWorkTime: formatTime(payload.settings.startWorkTime),
          endWorkTime: formatTime(payload.settings.endWorkTime),
        };
      }

      const { data } = await $authHost.put("/assistant/update", payload);

      if (data.code === 200) {
        dispatch(getAssistantById(data.assistant.id));
        return data.assistant;
      } else {
        errorToast(
          "Ошибка обновления ассистента: " +
            (data.message || "Неизвестная ошибка")
        );
        return null;
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере. Пожалуйста, попробуйте позже.");
        }
      } else if (error.request) {
        errorToast(
          "Ошибка связи с сервером. Пожалуйста, проверьте подключение."
        );
      } else {
        errorToast("Произошла ошибка: " + error.message);
      }

      dispatch(getAssistantList(userId));
      console.error("putAssistant error", error);
      return null;
    }
  };
};

export const deleteAssistant = (id) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.delete(`/assistant/delete?id=${id}`);

      if (data.code === 200) {
        dispatch(getAssistantList(userId));
        dispatch(setActiveAssistant(null));
      } else {
        errorToast(
          "Ошибка удаления ассистента: " +
            (data.message || "Неизвестная ошибка")
        );
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере. Пожалуйста, попробуйте позже.");
        }
      } else if (error.request) {
        errorToast(
          "Ошибка связи с сервером. Пожалуйста, проверьте подключение."
        );
      } else {
        errorToast("Произошла ошибка: " + error.message);
      }

      console.error("deleteAssistant error", error);
    }
  };
};

export const getInstructionsList = () => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.get(
        `/assistant/instruction/list?id=${userId}`
      );

      if (data.code === 200) {
        if (data.instructions) {
          dispatch(setDataInstructions(data.instructions));
          // console.log("getInstructionsList", data);
        }
      } else {
        errorToast(
          "Ошибка получения списка инструкций: " +
            (data.message || "Неизвестная ошибка")
        );
      }
    } catch (error) {
      if (error.response) {
        switch (error.response.status) {
          case 401:
            dispatch(removeUser());
            break;
          case 500:
            errorToast("Ошибка на сервере. Пожалуйста, попробуйте позже.");
            break;
          default:
            errorToast(
              "Произошла ошибка: " +
                error.message +
                ". Пожалуйста, попробуйте позже."
            );
        }
      } else {
        errorToast("Произошла ошибка: " + error.message);
      }
      console.error("getInstructionsList error", error);
    }
  };
};

export const assistantInstructionRebuild = (instructionData) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.post(
        `/assistant/instruction/rebuild`,
        instructionData
      );

      if (data.code === 200) {
        dispatch(setRebuildInstructionDialogId(data.dialogId));
        localStorage.setItem(
          "rebuildInstructionDialogId",
          JSON.stringify(data.dialogId)
        );
        dispatch(getDialog(data.dialogId));
        console.log("assistantInstructionRebuild", data);
      } else {
        errorToast(
          "Ошибка получения списка инструкций: " +
            (data.message || "Неизвестная ошибка")
        );
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере. Пожалуйста, попробуйте позже.");
        }
      } else {
        errorToast("Произошла ошибка: " + error.message);
      }
      console.error("assistantInstructionRebuild error", error);
    }
  };
};
